import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { RestClientService } from './rest.service'

import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class OnboardingPopupService {
    private onboarding: any

    get(onboarding: any) {
        this.onboarding = onboarding
    }

    open() {
        this.onboarding.open()
    }

    close() {
        this.onboarding.close()
    }
}

export class OnboardingService extends RestClientService {
    httproot = 'onboardingAPI/'

    constructor(protected override http: HttpClient) {
        super(http)
    }

    getOnboardingStatus(): Observable<any> {
        return this.get<any>(this.httproot + 'getOnboardingStatus/')
    }

    saveOnboardingStatus(data: any): Observable<any> {
        return this.post<any>(this.httproot + 'saveOnboardingStatus/', data)
    }

    saveOnboardingWelcome(data: any): Observable<any> {
        return this.post<any>(this.httproot + 'saveOnboardingWelcome/', data)
    }

    getOnboardingWelcome(): Observable<any> {
        return this.get<any>(this.httproot + 'getOnboardingWelcome/')
    }

    getOnboardingSettings(): Observable<any> {
        return this.get<any>(this.httproot + 'getOnboardingSettings/')
    }

    getOnboardingCompanyInfo() {
        return this.get<any>(this.httproot + 'getOnboardingCompanyInfo/')
    }

    saveOnboardingCompanyInfo(data: any) {
        return this.post<any>(
            this.httproot + 'saveOnboardingCompanyInfo/',
            data
        )
    }

    saveOnboardingBranches(data: any) {
        return this.post<any>(this.httproot + 'saveOnboardingBranches/', data)
    }

    saveOnboardingBranch(data: any) {
        return this.post<any>(this.httproot + 'saveOnboardingBranch/', data)
    }
}
